import { UpsellModel } from '@sosocio/creator/interfaces';
import ApiService from 'services/ApiService';

class UpsellService extends ApiService<UpsellModel> {
        constructor() {
                super('upsell');
        }
}

export default new UpsellService();
